import React from 'react';
import PropTypes from 'prop-types';
import ListView from 'components/ListView';
import ListRow from './ListRow';
import ListHeader from './ListHeader';

const Component = ({ sortable, onSort, list }) => {
    return (
        <ListView
            header={ ListHeader }
            list={ list }
            onSort={ onSort }
            renderListRow={ ({ columns, rowData }) => {
                return (
                    <ListRow
                        key={ `mission-${ rowData.start_time }-${ rowData.finish_time }` }
                        columns={ columns }
                        data={ rowData }
                    />
                ) ;
            } }
            dataKey="start_time"
        />
    );
};

Component.propTypes = {
    list: PropTypes.arrayOf(
        PropTypes.shape()
    ),
    sortable: PropTypes.bool,
    onSort: PropTypes.func,
};

Component.defaultProps = {
    list: [],
    sortable: false,
    onSort: () => {},
};

export default Component;
